const styles = theme => ({
  root: {},
  link: {
    display: 'inline-block',
    marginTop: theme.spacing(1),
    color: theme.palette.secondary.main,
    cursor: 'pointer',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginTop: theme.spacing(1),
  },
  itemContainer: {
    width: '100%',
    marginTop: theme.spacing(1) / 2,
    marginBottom: theme.spacing(1) / 2,
    flexGrow: 1,
    [theme.breakpoints.up('md')]: {
      width: '50%',
    },
  },
  title: {
    ...theme.typography.body2,
  },
  value: {
    ...theme.typography.body2,
    fontWeight: theme.typography.fontWeightBold,
    wordBreak: 'break-word',
  },
})

export default styles
